"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidAccountNumber = exports.getFormattedAccountNumber = void 0;
const getFormattedAccountNumber = accountNumber => {
  if (!accountNumber) return 'Ikke angitt';
  if (accountNumber.length === 13) {
    return accountNumber;
  }
  const first = accountNumber.substring(0, 4);
  const second = accountNumber.substring(4, 6);
  const third = accountNumber.substring(6, 11);
  return [first, second, third].join('.');
};
exports.getFormattedAccountNumber = getFormattedAccountNumber;
const isValidAccountNumber = (value, required = true) => {
  // stolen from https://no.wikipedia.org/wiki/MOD11

  if (!value) return !required;
  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const accountnrWithoutSpacesAndPeriods = value.replace(/[\s.]+/g, '');
  if (accountnrWithoutSpacesAndPeriods.length !== 11) {
    return false;
  } else {
    const checkNumber = parseInt(accountnrWithoutSpacesAndPeriods.charAt(10), 10);
    const accountnrWithoutCheckNumber = accountnrWithoutSpacesAndPeriods.substring(0, 10);
    let sum = 0;
    for (let index = 0; index < 10; index++) {
      sum += parseInt(accountnrWithoutCheckNumber.charAt(index), 10) * weights[index];
    }
    const remainder = sum % 11;
    return checkNumber === (remainder === 0 ? 0 : 11 - remainder);
  }
};
exports.isValidAccountNumber = isValidAccountNumber;